<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 6.5V3.5H13.5V6.5" stroke="currentColor" />
    <path d="M8 3V17" stroke="currentColor" />
    <path d="M5 16.5H11" stroke="currentColor" />
    <path class="cursor-blink" d="M17 2V18" stroke="currentColor" stroke-linejoin="bevel" />
  </svg>
</template>

<style scoped>
.cursor-blink {
  animation: blink 1.5s ease-in-out infinite;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
